import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faLocationDot,
  faPuzzlePiece,
  faRoute,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoteambuilding.png';
import '../CSS/Despedidas.css';

const LoretoChallengePT = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Loreto Challenge">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Grandes grupos • Enigmas • Indoor</div>

            <h1 className="er-partyTitle">
              Loreto <span className="er-partyTitleAccent">Challenge</span>
            </h1>

            <p className="er-partyLead">Um peddypaper indoor com enigmas!</p>
            <p className="er-partyText">
              Atividade pensada para grandes grupos: funciona como um peddypaper, mas em ambiente indoor,
              com riddles e desafios que fazem a equipa explorar, comunicar e resolver mistérios juntos.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Falar connosco
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faRoute} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Estilo peddypaper</h2>
              <p className="er-partyHeroCardText">
                Um percurso de pistas e missões — com a energia de um peddypaper, tudo em espaço indoor.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faPuzzlePiece} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Riddles e enigmas</h2>
              <p className="er-partyHeroCardText">
                Desafios pensados para testar lógica, observação e trabalho em equipa.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Grandes grupos</h2>
              <p className="er-partyHeroCardText">
                Ideal para turmas, empresas e grupos grandes que querem uma atividade dinâmica e envolvente.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faBuilding} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">100% indoor</h3>
              <p className="er-partyFeatureText">
                Sem depender do tempo: toda a aventura acontece em ambiente fechado.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Localização top</h2>
              <p className="er-partyFeatureText">
                No coração de Bragança, fácil de chegar e perfeito para eventos de grupo.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Equipa dedicada</h3>
              <p className="er-partyFeatureText">
                Apoio antes, durante e depois da atividade para tudo correr sem stress.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoretoChallengePT;
